import {Component, Inject, OnInit} from '@angular/core';
import {environment} from '~/environments/environment';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-leducation-financiere',
    templateUrl: './leducation-financiere.component.html',
    styleUrls: ['./leducation-financiere.component.scss']
})
export class LeducationFinanciereComponent implements OnInit {

    stripe = Stripe(environment.stripeKey);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<LeducationFinanciereComponent>,
        public authenticationService: AuthenticationService,
        private http: HttpClient,
    ) {
    }

    ngOnInit(): void {
    }

    onYesClick() {
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
            {plan: 'expert', duration: 'month'}).subscribe(
            session => {
                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
            },
            (error) => {
                console.log(error);
            });
    }
}
